/* Waiki — couche interactivité partagée (toutes pages du thème)
   Révélations au scroll · compteurs animés · barre d'achat sticky · header */
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* — Apparition au scroll — */
  if('IntersectionObserver' in window && !reduced){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    },{threshold:.15, rootMargin:'0px 0px -40px 0px'});
    document.querySelectorAll('.reveal,.stagger').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal,.stagger').forEach(function(el){ el.classList.add('in'); });
  }

  /* — Compteurs animés : <span data-count="1400" data-suffix="+" data-dec="0"> — */
  function fmt(n,dec){
    return dec ? n.toFixed(dec).replace('.',',') : Math.round(n).toLocaleString('fr-FR');
  }
  function animateCount(el){
    var target = parseFloat(el.dataset.count);
    var dec = parseInt(el.dataset.dec||'0',10);
    var suf = el.dataset.suffix||'', pre = el.dataset.prefix||'';
    if(reduced){ el.textContent = pre+fmt(target,dec)+suf; return; }
    var t0=null, dur=1400;
    function step(ts){
      if(!t0) t0=ts;
      var p = Math.min((ts-t0)/dur,1);
      var ease = 1-Math.pow(1-p,3);
      el.textContent = pre+fmt(target*ease,dec)+suf;
      if(p<1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if('IntersectionObserver' in window){
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ cio.unobserve(e.target); animateCount(e.target); }
      });
    },{threshold:.6});
    document.querySelectorAll('[data-count]').forEach(function(el){ cio.observe(el); });
  } else {
    document.querySelectorAll('[data-count]').forEach(animateCount);
  }

  /* — Header : ombre au scroll · barre d'achat sticky — */
  var header = document.querySelector('header');
  var bar = document.getElementById('stickyCta');
  function onScroll(){
    if(header) header.classList.toggle('scrolled', window.scrollY>10);
    if(bar) bar.classList.toggle('show', window.scrollY>520);
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();
